/**
 * Live broadcast list — shows nearby courses pushed via WS.
 */
export const BroadcastList = ({ broadcasts, onAccept, visible }) => {
  if (!visible || !broadcasts || broadcasts.length === 0) return null;
  return (
    <div className="space-y-3" data-testid="broadcast-list">
      {broadcasts.map((b) => (
        <div
          key={b.order_id}
          className="bg-gradient-to-r from-[#D4AF37]/20 via-[#D4AF37]/10 to-transparent border border-[#D4AF37]/50 rounded-[2rem] p-4 md:p-5 animate-in slide-in-from-top duration-300"
          data-testid={`broadcast-${b.order_id}`}
        >
          <div className="flex justify-between items-start gap-4 flex-wrap">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-[#D4AF37] text-[#0F172A] text-[9px] font-black uppercase tracking-widest animate-pulse">
                  📣 Live
                </span>
                <span className="text-[10px] text-[#D4AF37] font-black uppercase tracking-widest">
                  {b.delivery_fee
                    ? `${b.delivery_fee.toLocaleString()} FCFA`
                    : "Course disponible"}
                  {b.distance_km_from_me && ` · ${b.distance_km_from_me} km`}
                </span>
              </div>
              <p className="text-xs text-white font-bold mb-1">
                📍 {b.pickup_address || "Retrait"}
              </p>
              <p className="text-xs text-slate-300">
                ➡️ {b.delivery_address || "Destination"}
              </p>
            </div>
            <button
              onClick={() => onAccept(b.order_id)}
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-5 py-3 rounded-full font-black text-xs uppercase tracking-widest shadow-lg shadow-emerald-500/30 active:scale-95 flex-shrink-0"
              data-testid={`accept-broadcast-${b.order_id}`}
            >
              Accepter
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
